/*
  BIZORA COD PRO — interfaz de la ficha: botón COD, barra fija, WhatsApp y reseñas en carrusel.
  Requiere bz-product.js (window.BZ).
*/
(function () {
  if (!window.BZ) return;

  /* ---------- Botón COD ---------- */
  if (!customElements.get('bz-cod-button')) {
    customElements.define(
      'bz-cod-button',
      class extends HTMLElement {
        connectedCallback() {
          this.btn = this.querySelector('.bz-cb__btn');
          this.label = this.querySelector('[data-bz-text]');
          this.mode = this.dataset.mode;
          this.form = BZ.form(this.dataset.form);
          this.btn.addEventListener('click', () => this.go());
          if (this.form) {
            this.observer = new MutationObserver(() => this.mirror());
            this.observer.observe(this.form.closest('product-form') || this.form, {
              attributes: true,
              subtree: true,
              attributeFilter: ['disabled', 'aria-disabled', 'class'],
            });
            this.mirror();
          }
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        // Copia el estado (agotado / cargando) del botón nativo para no duplicar la lógica de Dawn.
        mirror() {
          var native = BZ.nativeSubmit(this.form);
          if (!native) return;
          var off = native.hasAttribute('disabled');
          var busy = native.getAttribute('aria-disabled') === 'true' || native.classList.contains('loading');
          this.btn.disabled = off;
          this.btn.classList.toggle('is-loading', busy && !off);
          if (this.label) {
            var span = native.querySelector('span');
            this.label.textContent = off && span ? span.textContent.trim() : this.label.dataset.label;
          }
        }

        go() {
          this.form = this.form || BZ.form(this.dataset.form);
          if (!this.form || this.btn.disabled) return;
          if (this.mode === 'buy_now') {
            this.btn.classList.add('is-loading');
            var p = BZ.buyNow(this.form);
            if (p) p.finally(() => this.btn.classList.remove('is-loading'));
          } else {
            BZ.submitForm(this.form);
          }
        }
      }
    );
  }

  /* ---------- Barra fija ---------- */
  if (!customElements.get('bz-sticky-atc')) {
    customElements.define(
      'bz-sticky-atc',
      class extends HTMLElement {
        connectedCallback() {
          this.sid = this.dataset.section;
          this.fmt = this.dataset.money;
          this.bar = this.querySelector('[data-bz-bar]');
          if (!this.bar) return;
          this.cta = this.bar.querySelector('[data-bz-cta]');
          this.form = BZ.form(this.dataset.form);
          var st = BZ.store(this.sid);
          if (!st.variant) {
            st.variant = {
              price: parseInt(this.dataset.price, 10) || 0,
              compare: parseInt(this.dataset.compare, 10) || 0,
              available: this.dataset.available === 'true',
            };
          }
          // Se saca al <body>: una barra fija dentro de un contenedor animado/transformado se descoloca.
          document.body.appendChild(this.bar);
          this.bar.addEventListener('click', (e) => {
            if (e.target.closest('[data-bz-cta]')) this.act();
          });

          var root = document.documentElement;
          if (this.dataset.mobile === 'true') root.classList.add('bz-sticky-m');
          if (this.dataset.desktop === 'bottom') root.classList.add('bz-sticky-d-bottom');

          this.observe();
          this.off = BZ.on(this.sid, (s) => this.update(s));
          this.update(BZ.store(this.sid));
        }

        disconnectedCallback() {
          if (this.io) this.io.disconnect();
          if (this.off) this.off();
          if (this.bar) this.bar.remove();
        }

        target() {
          var scope = document.getElementById('MainProduct-' + this.sid) || document;
          var cands = [
            scope.querySelector('bz-cod-button .bz-cb__btn'),
            scope.querySelector('.product-form__buttons'),
            this.form,
          ];
          return cands.find((el) => el && el.getClientRects().length) || this.form;
        }

        observe() {
          var el = this.target();
          if (!el || !('IntersectionObserver' in window)) {
            this.show(true);
            return;
          }
          var mode = this.dataset.show;
          this.io = new IntersectionObserver(
            (entries) => {
              var e = entries[entries.length - 1];
              if (mode === 'outside') this.show(!e.isIntersecting);
              else this.show(!e.isIntersecting && e.boundingClientRect.top < 0);
            },
            { threshold: 0 }
          );
          this.io.observe(el);
        }

        show(on) {
          this.bar.classList.toggle('is-visible', on);
          this.bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        }

        update(s) {
          var v = s.variant;
          var t = BZ.totals(s);
          var price = this.bar.querySelector('[data-bz-price]');
          var compare = this.bar.querySelector('[data-bz-compare]');
          if (v) {
            price.textContent = BZ.money(t.total, this.fmt);
            compare.hidden = !(t.strike > t.total);
            compare.textContent = BZ.money(t.strike, this.fmt);
            var img = this.bar.querySelector('[data-bz-img]');
            if (img && v.image) {
              img.removeAttribute('srcset');
              img.src = v.image;
            }
          }
          var badge = this.bar.querySelector('[data-bz-badge]');
          if (this.dataset.badgeMode === 'discount' && v) {
            var pct = v.compare > v.price ? Math.round(((v.compare - v.price) * 100) / v.compare) : 0;
            badge.hidden = !pct;
            badge.textContent = pct ? '-' + pct + '%' : '';
          }
          var canBuy = !v ? false : v.available !== false;
          if (this.dataset.action === 'scroll') this.cta.disabled = false;
          else this.cta.disabled = !canBuy;
        }

        act() {
          var action = this.dataset.action;
          this.form = this.form || BZ.form(this.dataset.form);
          if (action === 'add') BZ.submitForm(this.form);
          else if (action === 'buy_now') BZ.buyNow(this.form);
          else {
            var el = this.target();
            if (el) el.scrollIntoView({ behavior: BZ.reducedMotion() ? 'auto' : 'smooth', block: 'center' });
          }
        }
      }
    );
  }

  /* ---------- Pedir por WhatsApp ---------- */
  if (!customElements.get('whatsapp-order')) {
    customElements.define(
      'whatsapp-order',
      class extends HTMLElement {
        connectedCallback() {
          this.sid = this.dataset.section;
          this.link = this.querySelector('a');
          var st = BZ.store(this.sid);
          if (!st.variant) st.variant = { price: parseInt(this.dataset.price, 10) || 0, compare: 0, title: this.dataset.variant, available: true };
          this.off = BZ.on(this.sid, (s) => this.update(s));
          this.update(st);
        }

        disconnectedCallback() {
          if (this.off) this.off();
        }

        update(s) {
          var v = s.variant || {};
          var t = BZ.totals(s);
          var title = v.title !== undefined ? v.title : this.dataset.variant;
          if (title === 'Default Title') title = '';
          var text = (this.dataset.template || '')
            .split('[product]').join(this.dataset.product)
            .split('[variant]').join(title || '')
            .split('[quantity]').join(String(s.qty))
            .split('[price]').join(BZ.money(t.total || v.price || 0, this.dataset.money))
            .split('[url]').join(this.dataset.url + (v.id ? '?variant=' + v.id : ''));
          this.link.href = 'https://wa.me/' + this.dataset.phone + '?text=' + encodeURIComponent(text);
        }
      }
    );
  }

  /* ---------- Reseñas en carrusel ---------- */
  if (!customElements.get('bz-reviews')) {
    customElements.define(
      'bz-reviews',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.bz-rv__track');
          this.slides = Array.from(this.querySelectorAll('.bz-rv__slide'));
          this.dots = this.querySelector('.bz-rv__dots');
          if (this.slides.length < 2) return;

          this.slides.forEach((_, i) => {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'bz-rv__dot';
            b.setAttribute('aria-label', (i + 1) + ' / ' + this.slides.length);
            b.addEventListener('click', () => this.go(i, true));
            this.dots.appendChild(b);
          });
          this.dots.hidden = false;
          this.index = 0;
          this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });
          this.mark(0);

          var interval = parseInt(this.dataset.interval, 10) || 5000;
          if (this.dataset.autoplay === 'true' && !BZ.reducedMotion()) {
            var start = () => {
              this.stop();
              this.timer = setInterval(() => this.go((this.index + 1) % this.slides.length), interval);
            };
            ['pointerenter', 'focusin', 'touchstart'].forEach((ev) => this.addEventListener(ev, () => this.stop(), { passive: true }));
            ['pointerleave', 'focusout'].forEach((ev) => this.addEventListener(ev, start));
            start();
          }
        }

        disconnectedCallback() {
          this.stop();
        }

        stop() {
          clearInterval(this.timer);
        }

        onScroll() {
          var i = Math.round(this.track.scrollLeft / this.track.clientWidth);
          if (i !== this.index) this.mark(i);
        }

        mark(i) {
          this.index = i;
          Array.from(this.dots.children).forEach((d, n) => d.setAttribute('aria-current', n === i ? 'true' : 'false'));
        }

        go(i, user) {
          if (user) this.stop();
          this.track.scrollTo({ left: i * this.track.clientWidth, behavior: BZ.reducedMotion() ? 'auto' : 'smooth' });
          this.mark(i);
        }
      }
    );
  }
})();
